<template>
  <LoadingSpinner v-if="loading" />
  <Fragment v-else>
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs :items="[{ text: $t('meta.fractions'), name: 'fractions' }, { text: fraction.localized_name }]" />
      </template>
    </SectionHeader>
    <div class="body-content cf">
      <CompanyNav />
      <FractionsForm
        @submit="updateFraction"
        :companyUuid="companyUser.company_uuid"
        :fractionUuid="$route.params.fractionUuid"
      />
    </div>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'

import BreadCrumbs from '@/components/BreadCrumbs'
import FractionsForm from '@/components/Fractions/FractionsForm.vue'
import LoadingSpinner from '@/components/LoadingSpinner/index.vue'
import SectionHeader from '@/components/SectionHeader/index.vue'
import CompanyNav from '@/components/company_nav.vue'

import fractionsApi from '@/api/companies/fractions'

export default {
  components: {
    BreadCrumbs,
    CompanyNav,
    Fragment,
    FractionsForm,
    LoadingSpinner,
    SectionHeader,
  },
  inject: ['companyUser'],
  data: () => ({
    fraction: null,
    formData: {
      name: null,
      translations: {},
      avvNumber: null,
      internalId: null,
      color: null,
    },
    loading: true,
  }),
  methods: {
    async updateFraction(formData) {
      const params = {
        uuid: this.$route.params.fractionUuid,
        name: formData.name,
        translations: formData.translations,
        avv_number: formData.avvNumber,
        color: formData.coloring == 'manual' ? formData.color : null,
      }

      if (this.companyUser.company_type == 'industry') {
        params.internal_id = formData.internalId
        params.selectable_in_orders = formData.selectableInOrders
      }

      const response = await fractionsApi.update(this.companyUser.company_uuid, params)

      if (response.success) {
        this.$router.push(`/company/fractions`)
      }
    },
  },
  async created() {
    this.fraction = await fractionsApi.get(this.companyUser.company_uuid, this.$route.params.fractionUuid)
    this.loading = false
  },
}
</script>
